import type { JSX } from 'solid-js';

// One Overview stat cell (#195, spec §5 stats band): mono uppercase label over
// a big mono value inside a `.card`. `repo-stat*` classes are test hooks.
export function RepoStat(props: { label: string; value: string }): JSX.Element {
  return (
    <li class="card repo-stat">
      <div class="card__content">
        <p class="metric-grid__label">{props.label}</p>
        <p class="metric-grid__value repo-stat__value">{props.value}</p>
      </div>
    </li>
  );
}
